import React, { useState, useEffect } from 'react';
import useSWR from 'swr';
import { useOutletContext } from 'react-router-dom';
import DeleteIcon from './assets/images/delete-icon.svg';

const fetcher = url => {
    const token = localStorage.getItem('token');

    return fetch(url, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(res => {
        if (!res.ok) {
            const error = new Error('Yetkilendirme hatası veya sunucuya ulaşılamadı.');
            error.info = res.statusText;
            error.status = res.status;
            throw error;
        }
        return res.json();
    });
};

// İstatistikleri gösterecek basit bir component
const StatItem = ({ label, value, color }) => {
    
    const itemStyle = {
        padding: '8px 0',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px'
    };

    const labelStyle = {
        fontWeight: '500',
        backgroundColor: color || '#6c757d', // Varsayılan renk
        color: 'white',
        padding: '4px 12px',
        borderRadius: '12px',
        textAlign: 'center'
    };
    
    const valueStyle = {
        fontWeight: 'bold',
        fontSize: '16px',
        color: '#272935'
    };

    return (
        <div style={itemStyle}>
            <span style={labelStyle}>{label}</span>
            <span style={valueStyle}>{value || 0}</span>
        </div>
    );
};

// Karşılaştırma modunda tek bir dönemin tarih aralığını ve özet verilerini gösteren kutu
const KarsilastirmaKutu = ({ baslik, tarih, onBaslangicChange, onBitisChange, data, kaynakRenkleri, odemeRenkleri, urunRenkleri, styles }) => {
    return (
        <div style={styles.karsilastirmaKutu}>
            <div style={styles.karsilastirmaBaslik}>{baslik}</div>
            <div style={styles.dateRangeContainer}>
                <label>Başlangıç:</label>
                <input type="date" value={tarih.baslangic} onChange={e => onBaslangicChange(e.target.value)} style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins' }} />
                <label>Bitiş:</label>
                <input type="date" value={tarih.bitis} onChange={e => onBitisChange(e.target.value)} style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins' }} />
            </div>

            {data && (
                <div style={styles.karsilastirmaIcerik}>
                    <StatItem label="Toplam Sipariş" value={data.stats?.toplam_siparis} color="#555" />

                    <div style={styles.karsilastirmaBolum}>
                        <div style={styles.sutunBaslik}>Sipariş Kaynağı</div>
                        <StatItem label="Whatsapp" value={data.kaynaklar?.W} color={kaynakRenkleri.W} />
                        <StatItem label="Web Sitesi" value={data.kaynaklar?.S} color={kaynakRenkleri.S} />
                        <StatItem label="Resmi Evrak" value={data.kaynaklar?.R} color={kaynakRenkleri.R} />
                    </div>

                    <div style={styles.karsilastirmaBolum}>
                        <div style={styles.sutunBaslik}>Ödeme Türü</div>
                        <StatItem label="Kapıda Ödeme" value={data.odeme_yontemleri?.K} color={odemeRenkleri.K} />
                        <StatItem label="EFT / Havale" value={data.odeme_yontemleri?.E} color={odemeRenkleri.E} />
                        <StatItem label="Online Ödeme" value={data.odeme_yontemleri?.O} color={odemeRenkleri.O} />
                        <StatItem label="Kurum Ödemesi" value={data.odeme_yontemleri?.D} color={odemeRenkleri.D} />
                        <StatItem label="Ücretsiz Gönderi" value={data.odeme_yontemleri?.B} color={odemeRenkleri.B} />
                    </div>

                    <div style={styles.karsilastirmaBolum}>
                        <StatItem label="V3100 Toplam Baskı" value={data.urun_ozeti?.['V3100 Toplam Baskı']} color={urunRenkleri.makineBaski} />
                    </div>

                    <div style={styles.karsilastirmaBolum}>
                        <div style={styles.sutunBaslik}>Makine Baskıları</div>
                        <StatItem label="Orta Ebat (35x50)" value={data.urun_ozeti?.['Orta Ebat (35x50)']} color={urunRenkleri.makineBaski} />
                        <StatItem label="Küçük Ebat (21x30)" value={data.urun_ozeti?.['Küçük Ebat (21x30)']} color={urunRenkleri.makineBaski} />
                        <StatItem label="Mini Ebat (15x21)" value={data.urun_ozeti?.['Mini Ebat (15x21)']} color={urunRenkleri.makineBaski} />
                        <StatItem label="Uzun Ebat (35x70)" value={data.urun_ozeti?.['Uzun Ebat (35x70)']} color={urunRenkleri.makineBaski} />
                    </div>

                    <div style={styles.karsilastirmaBolum}>
                        <div style={styles.sutunBaslik}>Hazır Baskılar</div>
                        <StatItem label="Metrelik Ebat" value={data.urun_ozeti?.['Metrelik Ebat']} color={urunRenkleri.hazirBaski} />
                        <StatItem label="Büyük Ebat" value={data.urun_ozeti?.['Büyük Ebat']} color={urunRenkleri.hazirBaski} />
                        <StatItem label="Esmaül Hüsna" value={data.urun_ozeti?.['Esmaül Hüsna']} color={urunRenkleri.hazirBaski} />
                        <StatItem label="Özel Baskı" value={data.urun_ozeti?.['Özel Baskı']} color={urunRenkleri.hazirBaski} />
                    </div>
                </div>
            )}
        </div>
    );
};


// Ana ANASAYFA component'i
function Anasayfa() {
    // --- STATE'LER ---
    const [summaryData, setSummaryData] = useState(null);
    const [topProducts, setTopProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    const [aktifFiltre, setAktifFiltre] = useState('bugun');
    const [tarihAraligi, setTarihAraligi] = useState({
        baslangic: new Date().toISOString().split('T')[0],
        bitis: new Date().toISOString().split('T')[0]
    });

    const { user } = useOutletContext();
    const [aktifUrunKategorisi, setAktifUrunKategorisi] = useState('Metrelik Ebat');

    // KARŞILAŞTIRMA STATE'LERİ (seçimlik; diğer filtrelerle aynı 'aktifFiltre' grubunda)
    const karsilastirAktif = aktifFiltre === 'karsilastir';
    const [karsilastirTarih1, setKarsilastirTarih1] = useState({ baslangic: '', bitis: '' });
    const [karsilastirTarih2, setKarsilastirTarih2] = useState({ baslangic: '', bitis: '' });
    const [karsilastirData1, setKarsilastirData1] = useState(null);
    const [karsilastirData2, setKarsilastirData2] = useState(null);
    const [karsilastirLoading, setKarsilastirLoading] = useState(false);

    // NOTLAR STATE'LERİ
    const [aktifNotSayfasi, setAktifNotSayfasi] = useState(1); // 1: Genel Notlar, 2: Günlük Notlar
    const [yeniSabitNot, setYeniSabitNot] = useState('');
    const [duzenleNot, setDuzenleNot] = useState(null);
    const [duzenleIcerik, setDuzenleIcerik] = useState('');
    
    // Numara Değişikliği
    const [eskiNumara, setEskiNumara] = useState('');
    const [yeniNumara, setYeniNumara] = useState('');
    
    // Baskısı Gelmeyen
    const [gunlukNotTarih, setGunlukNotTarih] = useState(new Date().toISOString().split('T')[0]);
    const [secilenTelefon, setSecilenTelefon] = useState('');
    
    // Sorunlu Özel Baskı
    const [sorunluTelefon, setSorunluTelefon] = useState('');
    const [sorunluDurum, setSorunluDurum] = useState('Gelmedi');

    // Türkiye saatine göre tarihi YYYY-MM-DD formatında döndürür
    const getTurkeyDateString = (date) => {
        const turkeyTime = new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));
        const year = turkeyTime.getFullYear();
        const month = String(turkeyTime.getMonth() + 1).padStart(2, '0');
        const day = String(turkeyTime.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // İlk useEffect: Sadece filtre değiştiğinde tarih aralığını güncelle
    useEffect(() => {
        const now = new Date();
        const turkeyNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));
        
        // 'aralik' modunda kullanıcı manuel tarih girdiği, 'karsilastir' modunda ise kendi tarihleri kullanıldığı için güncelleme
        if (aktifFiltre === 'aralik' || aktifFiltre === 'karsilastir') {
            return;
        }

        let baslangic, bitis;
        bitis = getTurkeyDateString(turkeyNow);

        switch (aktifFiltre) {
            case 'hafta': {
                const haftaBasi = new Date(turkeyNow);
                const gunIndex = haftaBasi.getDay() === 0 ? 6 : haftaBasi.getDay() - 1;
                haftaBasi.setDate(haftaBasi.getDate() - gunIndex);
                baslangic = getTurkeyDateString(haftaBasi);
                break;
            }
            case 'ay': {
                const ayBasi = new Date(turkeyNow.getFullYear(), turkeyNow.getMonth(), 1);
                baslangic = getTurkeyDateString(ayBasi);
                break;
            }
            case 'yil': {
                const yilBasi = new Date(turkeyNow.getFullYear(), 0, 1);
                baslangic = getTurkeyDateString(yilBasi);
                break;
            }
            default: // 'bugun'
                baslangic = getTurkeyDateString(turkeyNow);
                bitis = baslangic;
                break;
        }

        setTarihAraligi({ baslangic, bitis });
    }, [aktifFiltre]);

    // İkinci useEffect: Tarih aralığı veya kategori değiştiğinde veri çek
    useEffect(() => {
        if (!tarihAraligi.baslangic || !tarihAraligi.bitis) {
            return;
        }

        setLoading(true);
        const kategoriParam = encodeURIComponent(aktifUrunKategorisi);
        
        Promise.all([
            fetch(`/api/dashboard/summary?start_date=${tarihAraligi.baslangic}&end_date=${tarihAraligi.bitis}`),
            fetch(`/api/dashboard/top-products?start_date=${tarihAraligi.baslangic}&end_date=${tarihAraligi.bitis}&category=${kategoriParam}`)
        ])
        .then(async ([summaryRes, topProductsRes]) => {
            const summary = await summaryRes.json();
            const topProducts = await topProductsRes.json();
            if (summary.hata || topProducts.hata) throw new Error(summary.hata || topProducts.hata || "Bilinmeyen bir hata oluştu.");
            setSummaryData(summary);
            setTopProducts(topProducts);
        })
        .catch(error => console.error("Dashboard verileri çekilirken hata:", error))
        .finally(() => setLoading(false));
    }, [tarihAraligi, aktifUrunKategorisi]);

    // Karşılaştırma panelleri için varsayılan tarih aralıklarını belirle:
    // Dönem 1 = geçen yılın bu ayı (ay başı - bugünün günü), Dönem 2 = bu yılın bu ayı (ay başı - bugün)
    useEffect(() => {
        const now = new Date();
        const turkeyNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));
        const yil = turkeyNow.getFullYear();
        const ay = turkeyNow.getMonth();
        const gun = turkeyNow.getDate();

        setKarsilastirTarih1({
            baslangic: getTurkeyDateString(new Date(yil - 1, ay, 1)),
            bitis: getTurkeyDateString(new Date(yil - 1, ay, gun))
        });
        setKarsilastirTarih2({
            baslangic: getTurkeyDateString(new Date(yil, ay, 1)),
            bitis: getTurkeyDateString(new Date(yil, ay, gun))
        });
    }, []);

    // Karşılaştırma aktifken, her iki dönem için özet verilerini çek
    useEffect(() => {
        if (aktifFiltre !== 'karsilastir') return;
        if (!karsilastirTarih1.baslangic || !karsilastirTarih1.bitis || !karsilastirTarih2.baslangic || !karsilastirTarih2.bitis) return;

        setKarsilastirLoading(true);
        Promise.all([
            fetch(`/api/dashboard/summary?start_date=${karsilastirTarih1.baslangic}&end_date=${karsilastirTarih1.bitis}`),
            fetch(`/api/dashboard/summary?start_date=${karsilastirTarih2.baslangic}&end_date=${karsilastirTarih2.bitis}`)
        ])
        .then(async ([res1, res2]) => {
            const veri1 = await res1.json();
            const veri2 = await res2.json();
            if (veri1.hata || veri2.hata) throw new Error(veri1.hata || veri2.hata || "Bilinmeyen bir hata oluştu.");
            setKarsilastirData1(veri1);
            setKarsilastirData2(veri2);
        })
        .catch(error => console.error("Karşılaştırma verileri çekilirken hata:", error))
        .finally(() => setKarsilastirLoading(false));
    }, [karsilastirAktif, karsilastirTarih1, karsilastirTarih2]);

    // NOTLAR İÇİN API HOOK'LARI
    const { data: sabitNotlar, mutate: sabitNotlariYenile } = useSWR('/api/sabit-notlar', fetcher, { refreshInterval: 5000 });
    const { data: numaraDegisiklikleri, mutate: numaraDegisiklikYenile } = useSWR(`/api/numara-degisikligi?tarih=${gunlukNotTarih}`, fetcher, { refreshInterval: 5000 });
    const { data: baskiGelmeyenler, mutate: baskiGelmeyenYenile } = useSWR(`/api/baskisi-gelmeyen?tarih=${gunlukNotTarih}`, fetcher, { refreshInterval: 5000 });
    const { data: sorunluBaskilar, mutate: sorunluBaskiYenile } = useSWR(`/api/sorunlu-ozel-baski?tarih=${gunlukNotTarih}`, fetcher, { refreshInterval: 5000 });
    const { data: siparisTelefonlari, mutate: siparisTelefonYenile } = useSWR(`/api/siparis-telefonlar/${gunlukNotTarih}`, fetcher);

    // Günlük not tarihi değiştiğinde telefon listesini ve baskı gelmeyen listesini güncelle
    useEffect(() => {
        siparisTelefonYenile();
        baskiGelmeyenYenile();
        numaraDegisiklikYenile();
        sorunluBaskiYenile();
    }, [gunlukNotTarih, siparisTelefonYenile, baskiGelmeyenYenile, numaraDegisiklikYenile, sorunluBaskiYenile]);

    // Her kullanıcıya isim hash'ine göre sabit renk atayan yardımcı fonksiyon
    const KULLANICI_RENK_PALETI = [
        { bg: '#e8f4fd', border: '#3783c2', text: '#1a5276' }, // mavi
        { bg: '#eafaf1', border: '#219852', text: '#1a6b38' }, // yeşil
        { bg: '#fef9e7', border: '#f4bf4a', text: '#7d6608' }, // sarı
        { bg: '#fdf2f8', border: '#a32e68', text: '#6c1d45' }, // pembe
        { bg: '#f4ecf7', border: '#6761a8', text: '#4a235a' }, // mor
        { bg: '#fef5ec', border: '#F3994A', text: '#784212' }, // turuncu
        { bg: '#e8f8f5', border: '#17bebb', text: '#0e6655' }, // turkuaz
        { bg: '#fdedec', border: '#dc3545', text: '#922b21' }, // kırmızı
    ];

    const getKullaniciRenk = (ekleyen) => {
        if (!ekleyen) return { bg: '#f8f9fa', border: '#e8e8e8', text: '#555' };
        // İsmin karakter kodlarının toplamını hash olarak kullan — her zaman aynı sonuç
        let hash = 0;
        for (let i = 0; i < ekleyen.length; i++) {
            hash += ekleyen.charCodeAt(i);
        }
        return KULLANICI_RENK_PALETI[hash % KULLANICI_RENK_PALETI.length];
    };

    const kaynakRenkleri = { W: '#25D366', S: '#3783c2', R: '#f4bf4a' };
    const odemeRenkleri = { K: '#17bebb', E: '#6761a8', O: '#2c6184', D: '#bb999c', B: '#a32e68' };
    const toplamSiparisRengi = '#555'; // Toplam Sipariş için varsayılan bir renk
    const urunRenkleri = {
        hazirBaski: '#9B52E1',
        makineBaski: '#219852',
        topUrun: '#F3994A'
    };

    // NOTLAR FONKSİYONLARI
    const handleSabitNotEkle = async (e) => {
        e.preventDefault();
        if (!yeniSabitNot.trim()) return;

        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/sabit-notlar', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ icerik: yeniSabitNot })
            });
            if (!response.ok) throw new Error('Not eklenemedi.');
            setYeniSabitNot('');
            sabitNotlariYenile();
        } catch (error) {
            console.error("Not ekleme hatası:", error);
            alert("Not eklenirken bir hata oluştu.");
        }
    };

    const handleSabitNotSil = async (notId) => {
        if (!window.confirm('Bu notu silmek istediğinize emin misiniz?')) return;

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/sabit-notlar/${notId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Not silinemedi.');
            sabitNotlariYenile();
        } catch (error) {
            console.error("Not silme hatası:", error);
            alert("Not silinirken bir hata oluştu.");
        }
    };

    const handleSabitNotGuncelle = async (notId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/sabit-notlar/${notId}`, {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ icerik: duzenleIcerik })
            });
            if (!response.ok) throw new Error('Not güncellenemedi.');
            setDuzenleNot(null);
            setDuzenleIcerik('');
            sabitNotlariYenile();
        } catch (error) {
            console.error("Not güncelleme hatası:", error);
            alert("Not güncellenirken bir hata oluştu.");
        }
    };

    const handleNumaraDegisikligiEkle = async (e) => {
        e.preventDefault();
        if (!eskiNumara.trim() || !yeniNumara.trim()) return;

        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/numara-degisikligi', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ eski_numara: eskiNumara, yeni_numara: yeniNumara, tarih: gunlukNotTarih })
            });
            if (!response.ok) throw new Error('Numara değişikliği eklenemedi.');
            setEskiNumara('');
            setYeniNumara('');
            numaraDegisiklikYenile();
        } catch (error) {
            console.error("Numara değişikliği ekleme hatası:", error);
            alert("Numara değişikliği eklenirken bir hata oluştu.");
        }
    };

    const handleNumaraDegisikligiSil = async (kayitId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/numara-degisikligi/${kayitId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Kayıt silinemedi.');
            numaraDegisiklikYenile();
        } catch (error) {
            console.error("Kayıt silme hatası:", error);
            alert("Kayıt silinirken bir hata oluştu.");
        }
    };

    const handleBaskiGelmeyenEkle = async () => {
        if (!secilenTelefon) return;

        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/baskisi-gelmeyen', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ telefon_son_4: secilenTelefon, tarih: gunlukNotTarih })
            });
            if (!response.ok) throw new Error('Kayıt eklenemedi.');
            setSecilenTelefon('');
            baskiGelmeyenYenile();
        } catch (error) {
            console.error("Kayıt ekleme hatası:", error);
            alert("Kayıt eklenirken bir hata oluştu.");
        }
    };

    const handleBaskiGelmeyenSil = async (kayitId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/baskisi-gelmeyen/${kayitId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Kayıt silinemedi.');
            baskiGelmeyenYenile();
        } catch (error) {
            console.error("Kayıt silme hatası:", error);
            alert("Kayıt silinirken bir hata oluştu.");
        }
    };

    const handleSorunluBaskiEkle = async () => {
        if (!sorunluTelefon.trim()) return;

        try {
            const token = localStorage.getItem('token');
            // Telefon numarasının son 4 hanesini al
            const son4 = sorunluTelefon.slice(-4);
            const response = await fetch('/api/sorunlu-ozel-baski', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ telefon_son_4: son4, durum: sorunluDurum, tarih: gunlukNotTarih })
            });
            if (!response.ok) throw new Error('Kayıt eklenemedi.');
            setSorunluTelefon('');
            sorunluBaskiYenile();
        } catch (error) {
            console.error("Kayıt ekleme hatası:", error);
            alert("Kayıt eklenirken bir hata oluştu.");
        }
    };

    const handleSorunluBaskiSil = async (kayitId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/sorunlu-ozel-baski/${kayitId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Kayıt silinemedi.');
            sorunluBaskiYenile();
        } catch (error) {
            console.error("Kayıt silme hatası:", error);
            alert("Kayıt silinirken bir hata oluştu.");
        }
    };

    const styles = {
        // --- ANA YERLEŞİM ---
        anasayfaContainer: { 
            display: 'flex', 
            gap: '15px', 
            alignItems: 'flex-start',
            fontFamily: "'Poppins', sans-serif"
        },
        dashboardBolumu: { 
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
        },

        main: { 
            fontFamily: 'Poppins, sans-serif',
            padding: '10px 10px',
            paddingRight: '500px', // Notlar kutusu için boşluk
            maxWidth: '1500px',
            marginLeft: '10px'
        },

        notlarBolumu: { 
            position: 'fixed',
            top: '110px',
            bottom: '20px',
            right: '20px',
            width: '450px', 
            maxHeight: 'calc(100vh - 110px)',
            background: 'white', 
            borderRadius: '10px', 
            boxShadow: '0 3px 10px rgba(0,0,0,0.08)', 
            border: '1px solid #e8e8e8', 
            display: 'flex', 
            flexDirection: 'column',
            overflow: 'hidden',
            zIndex: 1000,
            fontFamily: 'Poppins, sans-serif'
        },

        notlarBaslik: {
            padding: '10px 18px',
            borderBottom: '2px solid #e8e8e8',
            backgroundColor: '#f8f9fa',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            fontFamily: 'Poppins, sans-serif',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },

        notlarIcerik: {
            flex: 1,
            overflowY: 'auto',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            gap: '18px',
            fontFamily: 'Poppins'
        },

        notBolum: {
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            padding: '10px',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            border: '1px solid #f0f0f0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            fontFamily: 'Poppins'
        },

        notBolumBaslik: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '4px',
            fontFamily: 'Poppins'
        },

        gunlukNotBaslik: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '4px',
            flexWrap: 'wrap',
            gap: '8px',
            fontFamily: 'Poppins'
        },

        notListesi: {
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            maxHeight: '620px',
            overflowY: 'auto',
            padding: '3px',
            fontFamily: 'Poppins'
        },

        notKart: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '9px 11px',
            backgroundColor: '#f8f9fa',
            borderRadius: '5px',
            border: '1px solid #e8e8e8',
            fontSize: '12px',
            transition: 'all 0.2s ease',
            fontFamily: 'Poppins',
            '&:hover': {
                backgroundColor: '#f0f0f0'
            }
        },

        notEkleForm: {
            display: 'flex',
            gap: '5px',
            fontFamily: 'Poppins'
        },

        notInput: {
            flex: 1,
            padding: '5px 10px',
            border: '1px solid #d0d0d0',
            borderRadius: '5px',
            fontSize: '13px',
            fontFamily: 'Poppins',
            outline: 'none',
            transition: 'border-color 0.2s ease'
        },

        ekleBtn: {
            padding: '5px 14px',
            backgroundColor: '#219852',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 5px rgba(33, 152, 82, 0.25)',
            fontFamily: 'Poppins'
        },

        kaydetBtn: {
            padding: '4px 12px',
            backgroundColor: '#219852',
            color: 'white',
            border: 'none',
            borderRadius: '7px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 5px rgba(33, 152, 82, 0.25)',
            fontFamily: 'Poppins'
        },

        iptalBtn: {
            padding: '4px 12px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '7px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            fontFamily: 'Poppins'
        },

        duzenleBtn: {
            padding: '3px 10px',
            backgroundColor: '#F3994A',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 4px rgba(243, 153, 74, 0.25)',
            fontFamily: 'Poppins'
        },

        silBtn: {
            padding: '3px 10px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 4px rgba(220, 53, 69, 0.25)',
            fontFamily: 'Poppins'
        },

        altBolum: {
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            padding: '8px',
            backgroundColor: '#fafafa',
            borderRadius: '7px',
            border: '1px solid #e8e8e8',
            fontFamily: 'Poppins'
        },

        altBolumBaslik: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '8px',
            fontFamily: 'Poppins'
        },

        numaraForm: {
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            flexWrap: 'wrap',
            fontFamily: 'Poppins'
        },

        kutuInput: {
            flex: 1,
            minWidth: '70px',
            maxWidth: '130px',
            padding: '4px 8px',
            border: '1px solid #d0d0d0',
            borderRadius: '5px',
            fontSize: '12px',
            fontFamily: 'Poppins',
            outline: 'none',
            transition: 'border-color 0.2s ease'
        },

        kutuListesi: {
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            maxHeight: '130px',
            overflowY: 'auto',
            fontFamily: 'Poppins'
        },

        kutuItem: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '7px 10px',
            backgroundColor: 'white',
            borderRadius: '5px',
            fontSize: '11px',
            gap: '8px',
            border: '1px solid #e8e8e8',
            fontFamily: 'Poppins'
        },

        kutuSilBtn: {
            padding: '3px 10px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            fontFamily: 'Poppins'
        },

        kutuGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '6px',
            maxHeight: '130px',
            overflowY: 'auto',
            fontFamily: 'Poppins'
        },

        gridItem: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '4px 6px',
            backgroundColor: 'white',
            borderRadius: '5px',
            fontSize: '11px',
            fontWeight: '600',
            border: '1px solid #e8e8e8',
            fontFamily: 'Poppins'
        },

        gridItemSorunlu: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '4px 6px',
            backgroundColor: 'white',
            borderRadius: '5px',
            fontSize: '11px',
            border: '1px solid #e8e8e8',
            fontFamily: 'Poppins'
        },

        gridSilBtn: {
            padding: '2px 6px',
            backgroundColor: 'transparent',
            color: '#dc3545',
            border: '1px solid #dc3545',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '10px',
            fontWeight: 'bold',
            transition: 'all 0.2s ease',
            fontFamily: 'Poppins'
        },

        // --- DASHBOARD KUTULARI ---
        mainBox: { 
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '18px',
        },
        sutun: {
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            border: '1px solid #e0e0e0',
            padding: '15px',
            display: 'flex',
            flexDirection: 'column'
        },
        sutunBaslik: {
            fontWeight: '600', // 'semibold' yerine standart bir değer
            paddingBottom: '8px', 
            borderBottom: '2px solid #f0f0f0', 
            marginBottom: '8px',
            fontSize: '16px'
        },
        toplamSiparisCard: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1 // İçinde bulunduğu sütunun tamamını kaplaması için
        },
        toplamSiparisValue: {
            fontSize: '100px', // 48px'ten 50px'ye güncellendi
            fontWeight: 'bold',
            color: '#272935',
            lineHeight: '1',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center', // Dikeyde ortalar
            alignItems: 'center',
            flex: 1 
        },

        toplamSiparisLabel: {
            fontSize: '16px',
            color: '#6c757d',
            marginTop: '10px'
        },

        header: { 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 0 // Ana container'dan gap geldiği için sıfırlandı
        },

        welcome: { 
            fontSize: '24px', 
            fontWeight: '600', 
            color: '#272935',
            margin: '20px 0 5px 0'
        },
        
        // --- ÜÇÜNCÜ KUTU (ÜRÜN ÖZETİ) ---
        urunOzetKutusu: {
            gridColumn: 'span 3', // 3 sütunluk yer kaplar
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            border: '1px solid #e0e0e0',
            padding: '15px'
        },
        urunOzetGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '15px 40px', // Dikey ve Yatay boşluklar
            marginTop: '10px'
        },

        // --- FİLTRELEME ---
        filterContainer: {
            display: 'flex', 
            gap: '10px',
            marginBottom: '15px'
        },

        // --- KARŞILAŞTIRMA ---
        karsilastirmaBolumu: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '18px',
            marginTop: '15px'
        },
        karsilastirmaKutu: {
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            border: '1px solid #e0e0e0',
            padding: '15px',
            display: 'flex',
            flexDirection: 'column'
        },
        karsilastirmaBaslik: {
            fontWeight: '600',
            fontSize: '16px',
            marginBottom: '10px',
            color: '#272935'
        },
        karsilastirmaIcerik: {
            display: 'flex',
            flexDirection: 'column'
        },
        karsilastirmaBolum: {
            marginTop: '14px'
        },

        filterButton: (isActive) => ({
            padding: '8px 20px',
            fontFamily: "'Poppins', sans-serif",
            borderRadius: '10px',
            cursor: 'pointer',
            fontWeight: '500',
            width: '140px',
            textAlign: 'center',
            transition: 'all 0.2s ease',
            background: isActive ? '#3783c2' : '#ffffff', 
            color: isActive ? 'white' : '#333',
            border: isActive ? '1px solid #3783c2' : '1px solid #cccccc',
        }),
    
        dateRangeContainer: { 
            background: '#dfe6e9', 
            padding: '15px', 
            borderRadius: '8px', 
            marginBottom: '15px', 
            display: 'flex', 
            gap: '15px', 
            alignItems: 'center',
            // --- YENİ EKLENEN STİL ---
            // Bu kapsayıcı içindeki tüm metinlerin fontunu Poppins yapar.
            fontFamily: "'Poppins'"
        }
     };
    
    // --- RENDER BÖLÜMÜ ---
    if (loading) return <div style={styles.main}><h2>Veriler Yükleniyor...</h2></div>;

    return (
        <div style={styles.main}>
             <header style={styles.header}>
            <h1 style={styles.welcome}>
                    Tekrar Hoş Geldiniz, {user?.gorunen_ad || 'Kullanıcı'}
                </h1>
        </header>

        {/* ANA KAPSAYICI (Dashboard ve Mesajlaşmayı yan yana tutar) */}
        <div style={styles.anasayfaContainer}>
            <div style={styles.dashboardBolumu}>
            {/* Filtre Butonları */}
            <div style={styles.filterContainer}>
                    {['bugun', 'hafta', 'ay', 'yil', 'aralik'].map(f => {
                        let metin = f.charAt(0).toUpperCase() + f.slice(1);
                        if (f === 'bugun') metin = 'Bugün';
                        if (f === 'hafta') metin = 'Bu Hafta';
                        if (f === 'ay') metin = 'Bu Ay';
                        if (f === 'yil') metin = 'Bu Yıl';
                        if (f === 'aralik') metin = 'Tarih Aralığı';
                        
                        return (
                            <button key={f} onClick={() => setAktifFiltre(f)} style={styles.filterButton(aktifFiltre === f)}>
                                {metin}
                            </button>
                        )
                    })}
                    <button onClick={() => setAktifFiltre('karsilastir')} style={{ ...styles.filterButton(karsilastirAktif), marginLeft: 'auto' }}>
                        Karşılaştır
                    </button>
                </div>

            {/* Tarih Aralığı Seçimi */}
            {aktifFiltre === 'aralik' && (
                    <div style={styles.dateRangeContainer}>
                        <label>Başlangıç:</label>
                        <input type="date" value={tarihAraligi.baslangic} onChange={e => setTarihAraligi(p => ({...p, baslangic: e.target.value}))} style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins' }} />
                        <label>Bitiş:</label>
                        <input type="date" value={tarihAraligi.bitis} onChange={e => setTarihAraligi(p => ({...p, bitis: e.target.value}))} style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins' }} />
                    </div>
            )}

            {/* Karşılaştırma Panelleri */}
            {karsilastirAktif && (
                <div style={styles.karsilastirmaBolumu}>
                    {karsilastirLoading && (
                        <p style={{ gridColumn: 'span 2', textAlign: 'center', color: '#888' }}>Karşılaştırma verileri yükleniyor...</p>
                    )}
                    <KarsilastirmaKutu
                        baslik="Dönem 1"
                        tarih={karsilastirTarih1}
                        onBaslangicChange={(deger) => setKarsilastirTarih1(p => ({ ...p, baslangic: deger }))}
                        onBitisChange={(deger) => setKarsilastirTarih1(p => ({ ...p, bitis: deger }))}
                        data={karsilastirData1}
                        kaynakRenkleri={kaynakRenkleri}
                        odemeRenkleri={odemeRenkleri}
                        urunRenkleri={urunRenkleri}
                        styles={styles}
                    />
                    <KarsilastirmaKutu
                        baslik="Dönem 2"
                        tarih={karsilastirTarih2}
                        onBaslangicChange={(deger) => setKarsilastirTarih2(p => ({ ...p, baslangic: deger }))}
                        onBitisChange={(deger) => setKarsilastirTarih2(p => ({ ...p, bitis: deger }))}
                        data={karsilastirData2}
                        kaynakRenkleri={kaynakRenkleri}
                        odemeRenkleri={odemeRenkleri}
                        urunRenkleri={urunRenkleri}
                        styles={styles}
                    />
                </div>
            )}
            
            {!karsilastirAktif && summaryData && (
            <>
                {/* İLK ANA KUTU */}
                <div style={styles.mainBox}>
                    {/* Sütun 1: Toplam Sipariş */}
                    <div style={styles.sutun}>
                        <div style={styles.sutunBaslik}>Toplam Sipariş</div>
                            <div style={styles.toplamSiparisValue}>
                                {summaryData.stats?.toplam_siparis || 0}
                            </div>
                    </div>
                    {/* Sütun 2: Sipariş Kaynağı */}
                    <div style={styles.sutun}>
                        <div style={styles.sutunBaslik}>Sipariş Kaynağı</div>
                        <StatItem label="Whatsapp" value={summaryData.kaynaklar?.W} color={kaynakRenkleri.W} />
                        <StatItem label="Web Sitesi" value={summaryData.kaynaklar?.S} color={kaynakRenkleri.S} />
                        <StatItem label="Resmi Evrak" value={summaryData.kaynaklar?.R} color={kaynakRenkleri.R} />
                    </div>

                    {/* Sütun 3: Ödeme Türü */}
                    <div style={styles.sutun}>
                        <div style={styles.sutunBaslik}>Ödeme Türü</div>
                        <StatItem label="Kapıda Ödeme" value={summaryData.odeme_yontemleri?.K} color={odemeRenkleri.K} />
                        <StatItem label="EFT / Havale" value={summaryData.odeme_yontemleri?.E} color={odemeRenkleri.E} />
                        <StatItem label="Online Ödeme" value={summaryData.odeme_yontemleri?.O} color={odemeRenkleri.O} />
                        <StatItem label="Kurum Ödemesi" value={summaryData.odeme_yontemleri?.D} color={odemeRenkleri.D} />                        <StatItem label="Ücretsiz Gönderi" value={summaryData.odeme_yontemleri?.B} color={odemeRenkleri.B} />                    </div>
                </div>
                {/* İKİNCİ ANA KUTU */}
                <div style={styles.mainBox}>
                    <div style={styles.sutun}>
                        <div style={styles.sutunBaslik}>V3100 Toplam Baskı</div>
                        {/* Toplam Sipariş için kullandığımız özel kartın aynısı */}
                            <div style={styles.toplamSiparisValue}>
                                {summaryData.urun_ozeti?.['V3100 Toplam Baskı'] || 0}
                            </div>
                        </div>
                    {/* Sütun 2: Makine Baskıları 1 */}
                    <div style={styles.sutun}>
                        <div style={styles.sutunBaslik}>Makine Baskıları</div>
                        <StatItem label="Orta Ebat (35x50)" value={summaryData.urun_ozeti?.['Orta Ebat (35x50)']} color={urunRenkleri.makineBaski} />
                        <StatItem label="Küçük Ebat (21x30)" value={summaryData.urun_ozeti?.['Küçük Ebat (21x30)']} color={urunRenkleri.makineBaski} />
                        <StatItem label="Mini Ebat (15x21)" value={summaryData.urun_ozeti?.['Mini Ebat (15x21)']} color={urunRenkleri.makineBaski} />
                        <StatItem label="Uzun Ebat (35x70)" value={summaryData.urun_ozeti?.['Uzun Ebat (35x70)']} color={urunRenkleri.makineBaski} />
                    </div>
                    {/* Sütun 3: Hazır Baskılar */}
                    <div style={styles.sutun}>
                        <div style={styles.sutunBaslik}>Hazır Baskılar</div>
                        <StatItem label="Metrelik Ebat" value={summaryData.urun_ozeti?.['Metrelik Ebat']} color={urunRenkleri.hazirBaski} />
                        <StatItem label="Büyük Ebat" value={summaryData.urun_ozeti?.['Büyük Ebat']} color={urunRenkleri.hazirBaski} />
                        <StatItem label="Esmaül Hüsna" value={summaryData.urun_ozeti?.['Esmaül Hüsna']} color={urunRenkleri.hazirBaski} />
                        <StatItem label="Özel Baskı" value={summaryData.urun_ozeti?.['Özel Baskı']} color={urunRenkleri.hazirBaski} />
                    </div>   
                </div>
                {/* ÜÇÜNCÜ ANA KUTU */}
                <div style={styles.urunOzetKutusu}>
                    {/* Kategori Filtre Butonları */}
                    <div style={{ display: 'flex', gap: '10px', borderBottom: '2px solid #f0f0f0', paddingBottom: '15px' }}>
                        {['Metrelik Ebat', 'Büyük Ebat', 'Esmaül Hüsna', 'Yan Ürünler'].map(kategori => (
                            <button key={kategori} onClick={() => setAktifUrunKategorisi(kategori)} style={styles.filterButton(aktifUrunKategorisi === kategori)}>
                                {kategori}
                            </button>
                        ))}
                    </div>

                    {/* Ürün Listesi Grid'i */}
                    <div style={styles.urunOzetGrid}>
                        {topProducts.length > 0 ? (
                            topProducts.map((urun, index) => (
                                <StatItem key={index} label={urun.urun_adi} value={urun.toplam_adet} color={urunRenkleri.topUrun} />
                            ))
                        ) : (
                            <p style={{ gridColumn: 'span 3', textAlign: 'center', color: '#888' }}>Bu kategoride veri bulunamadı.</p>
                        )}
                    </div>
                </div>
            </>
            )}
        </div>
        
        {/* NOTLAR BÖLÜMÜ */}
        <div style={styles.notlarBolumu}>
            <div style={styles.notlarBaslik}>
                <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                    <h4 style={{margin: 0, fontSize: '15px', fontWeight: 700, color: '#2c3e50', letterSpacing: '0.5px', fontFamily: 'Poppins'}}>
                        {aktifNotSayfasi === 1 ? 'Genel Notlar' : 'Günlük Notlar'}
                    </h4>
                    {aktifNotSayfasi === 2 && (
                        <div style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
                            <label style={{fontSize: '11px', fontWeight: '500', whiteSpace: 'nowrap', fontFamily: 'Poppins', color: '#666'}}>Gün</label>
                            <input
                                type="date"
                                value={gunlukNotTarih}
                                onChange={(e) => setGunlukNotTarih(e.target.value)}
                                style={{padding: '5px 7px', border: '1px solid #d0d0d0', borderRadius: '5px', fontFamily: 'Poppins', fontSize: '11px', maxWidth: '130px'}}
                            />
                        </div>
                    )}
                </div>
                <div style={{display: 'flex', gap: '8px'}}>
                    <button
                        onClick={() => setAktifNotSayfasi(1)}
                        style={{
                            padding: '5px 10px',
                            border: aktifNotSayfasi === 1 ? '1px solid #3884C2' : '1px solid #ccc',
                            borderRadius: '5px',
                            background: aktifNotSayfasi === 1 ? '#3884C2' : 'white',
                            color: aktifNotSayfasi === 1 ? 'white' : 'black',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: aktifNotSayfasi === 1 ? '600' : '500',
                            fontFamily: 'Poppins',
                            transition: 'all 0.2s'
                        }}
                    >
                        1
                    </button>
                    <button
                        onClick={() => setAktifNotSayfasi(2)}
                        style={{
                            padding: '5px 10px',
                            border: aktifNotSayfasi === 2 ? '1px solid #3884C2' : '1px solid #ccc',
                            borderRadius: '5px',
                            background: aktifNotSayfasi === 2 ? '#3884C2' : 'white',
                            color: aktifNotSayfasi === 2 ? 'white' : 'black',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: aktifNotSayfasi === 2 ? '600' : '500',
                            fontFamily: 'Poppins',
                            transition: 'all 0.2s'
                        }}
                    >
                        2
                    </button>
                </div>
            </div>

            <div style={styles.notlarIcerik}>
                {/* SABİT NOTLAR - SAYFA 1 */}
                {aktifNotSayfasi === 1 && (
                <div style={styles.notBolum}>
                    <form onSubmit={handleSabitNotEkle} style={styles.notEkleForm}>
                        <input
                            type="text"
                            value={yeniSabitNot}
                            onChange={(e) => setYeniSabitNot(e.target.value)}
                            placeholder="Yeni not ekle"
                            style={styles.notInput}
                        />
                        <button type="submit" style={styles.ekleBtn}>Ekle</button>
                    </form>

                    <div style={styles.notListesi}>
                        {sabitNotlar && sabitNotlar.map(not => {
                            const renk = getKullaniciRenk(not.ekleyen);
                            return (
                                <div key={not.id} style={{
                                    ...styles.notKart,
                                    backgroundColor: renk.bg,
                                    borderLeft: `3px solid ${renk.border}`,
                                    borderTop: `1px solid ${renk.border}22`,
                                    borderRight: `1px solid ${renk.border}22`,
                                    borderBottom: `1px solid ${renk.border}22`,
                                }}>
                                    {duzenleNot === not.id ? (
                                        <div style={{width: '100%'}}>
                                            <input
                                                type="text"
                                                value={duzenleIcerik}
                                                onChange={(e) => setDuzenleIcerik(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSabitNotGuncelle(not.id);
                                                    } else if (e.key === 'Escape') {
                                                        setDuzenleNot(null);
                                                        setDuzenleIcerik('');
                                                    }
                                                }}
                                                autoFocus
                                                style={{width: '100%', padding: '6px 8px', border: `1px solid ${renk.border}`, borderRadius: '5px', fontFamily: 'Poppins', fontSize: '12px', backgroundColor: 'white'}}
                                            />
                                            <div style={{marginTop: '8px', display: 'flex', gap: '8px'}}>
                                                <button onClick={() => handleSabitNotGuncelle(not.id)} style={styles.kaydetBtn}>Kaydet</button>
                                                <button onClick={() => { setDuzenleNot(null); setDuzenleIcerik(''); }} style={styles.iptalBtn}>İptal</button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: '2px'}}>
                                                <span style={{fontSize: '12px', fontFamily: 'Poppins', color: '#2c3e50'}}>{not.icerik}</span>
                                                {not.ekleyen && (
                                                    <span style={{fontSize: '10px', fontFamily: 'Poppins', color: renk.text, fontWeight: '600', opacity: 0.8}}>
                                                        {not.ekleyen}
                                                    </span>
                                                )}
                                            </div>
                                            <div style={{display: 'flex', gap: '8px', flexShrink: 0}}>
                                                <button onClick={() => { setDuzenleNot(not.id); setDuzenleIcerik(not.icerik); }} style={styles.duzenleBtn}>Düzenle</button>
                                                <button onClick={() => handleSabitNotSil(not.id)} style={styles.silBtn}>Sil</button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                )}

                {/* GÜNLÜK NOTLAR - SAYFA 2 */}
                {aktifNotSayfasi === 2 && (
                <div style={{...styles.notBolum, gap: '15px'}}>

                    {/* Numara Değişikliği */}
                    <div style={styles.altBolum}>
                        <div style={styles.altBolumBaslik}>
                            <span style={{backgroundColor: '#F3994A', color: 'white', padding: '5px 10px', borderRadius: '5px', fontSize: '11px', fontWeight: '500', boxShadow: '0 2px 4px rgba(243, 153, 74, 0.3)', fontFamily: 'Poppins'}}>
                                Numara Değişikliği
                            </span>
                        </div>

                        <div style={styles.numaraForm}>
                            <input
                                type="text"
                                value={eskiNumara}
                                onChange={(e) => setEskiNumara(e.target.value)}
                                placeholder="Eski"
                                style={styles.kutuInput}
                            />
                            <span style={{fontSize: '16px', fontWeight: 'bold', color: '#666', flexShrink: 0, fontFamily: 'Poppins'}}>≫</span>
                            <input
                                type="text"
                                value={yeniNumara}
                                onChange={(e) => setYeniNumara(e.target.value)}
                                placeholder="Yeni"
                                style={styles.kutuInput}
                            />
                            <button onClick={handleNumaraDegisikligiEkle} style={{...styles.ekleBtn, flexShrink: 0}}>Ekle</button>
                        </div>

                        <div style={styles.kutuListesi}>
                            {numaraDegisiklikleri && numaraDegisiklikleri.map(kayit => (
                                <div key={kayit.id} style={styles.kutuItem}>
                                    <span style={{fontSize: '11px', fontFamily: 'Poppins'}}>{kayit.eski_numara}</span>
                                    <span style={{fontSize: '14px', color: '#666', fontFamily: 'Poppins'}}>≫</span>
                                    <span style={{fontSize: '11px', fontFamily: 'Poppins'}}>{kayit.yeni_numara}</span>
                                    <button onClick={() => handleNumaraDegisikligiSil(kayit.id)} style={styles.kutuSilBtn}>Sil</button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Baskısı Gelmeyen */}
                    <div style={styles.altBolum}>
                        <div style={styles.altBolumBaslik}>
                            <span style={{backgroundColor: '#17bebb', color: 'white', padding: '5px 10px', borderRadius: '5px', fontSize: '11px', fontWeight: '500', boxShadow: '0 2px 4px rgba(23, 190, 187, 0.3)', fontFamily: 'Poppins'}}>
                                Baskısı Gelmeyen
                            </span>
                            <div style={{display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap'}}>
                                <select
                                    value={secilenTelefon}
                                    onChange={(e) => setSecilenTelefon(e.target.value)}
                                    style={{padding: '5px 8px', border: '1px solid #d0d0d0', borderRadius: '5px', fontFamily: 'Poppins', fontSize: '11px', minWidth: '85px', maxWidth: '115px'}}
                                >
                                    <option value="">Seçiniz</option>
                                    {siparisTelefonlari && siparisTelefonlari.map(tel => (
                                        <option key={tel} value={tel}>{tel}</option>
                                    ))}
                                </select>
                                <button onClick={handleBaskiGelmeyenEkle} style={{...styles.ekleBtn, flexShrink: 0}}>Ekle</button>
                            </div>
                        </div>

                        <div style={styles.kutuGrid}>
                            {baskiGelmeyenler && baskiGelmeyenler.map(kayit => (
                                <div key={kayit.id} style={styles.gridItem}>
                                    <span style={{fontSize: '11px', fontWeight: '600', fontFamily: 'Poppins'}}>{kayit.telefon_son_4}</span>
                                    <img 
                                        src={DeleteIcon} 
                                        alt="Sil" 
                                        onClick={() => handleBaskiGelmeyenSil(kayit.id)}
                                        style={{width: '14px', height: '14px', cursor: 'pointer'}} 
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Sorunlu Özel Baskı */}
                    <div style={styles.altBolum}>
                        <div style={styles.altBolumBaslik}>
                            <span style={{backgroundColor: '#6761a8', color: 'white', padding: '5px 10px', borderRadius: '5px', fontSize: '11px', fontWeight: '500', boxShadow: '0 2px 4px rgba(103, 97, 168, 0.3)', fontFamily: 'Poppins'}}>
                                Sorunlu Özel Baskı
                            </span>
                            <div style={{display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap'}}>
                                <select
                                    value={sorunluTelefon}
                                    onChange={(e) => setSorunluTelefon(e.target.value)}
                                    style={{padding: '5px 8px', border: '1px solid #d0d0d0', borderRadius: '5px', fontFamily: 'Poppins', fontSize: '11px', minWidth: '85px', maxWidth: '115px'}}
                                >
                                    <option value="">Seçiniz</option>
                                    {siparisTelefonlari && siparisTelefonlari.map(tel => (
                                        <option key={tel} value={tel}>{tel}</option>
                                    ))}
                                </select>
                                <select
                                    value={sorunluDurum}
                                    onChange={(e) => setSorunluDurum(e.target.value)}
                                    style={{padding: '5px 8px', border: '1px solid #d0d0d0', borderRadius: '5px', fontFamily: 'Poppins', fontSize: '11px', minWidth: '75px', maxWidth: '90px'}}
                                >
                                    <option value="Gelmedi">Gelmedi</option>
                                    <option value="Eksik">Eksik</option>
                                    <option value="Hatalı">Hatalı</option>
                                </select>
                                <button onClick={handleSorunluBaskiEkle} style={{...styles.ekleBtn, flexShrink: 0}}>Ekle</button>
                            </div>
                        </div>

                        <div style={styles.kutuGrid}>
                            {sorunluBaskilar && sorunluBaskilar.map(kayit => (
                                <div key={kayit.id} style={styles.gridItemSorunlu}>
                                    <div style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
                                        <span style={{fontWeight: '600', fontSize: '11px', fontFamily: 'Poppins'}}>{kayit.telefon_son_4}</span>
                                        <span style={{fontSize: '10px', color: '#666', fontFamily: 'Poppins'}}>({kayit.durum})</span>
                                    </div>
                                    <img 
                                        src={DeleteIcon} 
                                        alt="Sil" 
                                        onClick={() => handleSorunluBaskiSil(kayit.id)}
                                        style={{width: '14px', height: '14px', cursor: 'pointer'}} 
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                )}
            </div>
        </div>
        
            </div>
        </div>
    );
}


export default Anasayfa;
